import Plugins from './Plugins';

// types
import { NavItemType } from 'types/menu';
import Icons from './icons';

// ==============================|| MENU ITEMS ||============================== //

const PluginMenuItems: { items: NavItemType[] } = {
  // items: [widget, applications, formsTables, chartsMap, pages, other]
  items: [Plugins, Icons]
};

export default PluginMenuItems;
